<template>
  <div class="flex act-container">
    <div>
      <act-preview phoneHeaderFixed navigationBg="transparent">
        <div
          class="slot"
          :style="{ backgroundImage: 'url(' + ruleForm.gameBgp + ')' }"
        >
          <div class="change-bg">
            <div class="upload-img pointer" @click="toggleShow('gameBgp')">
              更换背景
            </div>
          </div>
          <div class="title-img prev-upload">
            <div
              class="upload-img"
              v-if="ruleForm.gameBgp2"
              @click="toggleShow('gameBgp2')"
            >
              <span class="hmicon icon-shangchuantupian1"></span>
            </div>
            <img :src="ruleForm.gameBgp2" alt="" />
          </div>
          <div class="card-back">
            <div class="normarl-card-back prev-upload" v-show="showCardBack">
              <div
                class="upload-img"
                v-if="ruleForm.gameBgp3"
                @click="toggleShow('gameBgp3')"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>
              <div
                class="switch-card-bg visual-btn"
                @click="showCardBack = !showCardBack"
              >
                <span>查看合成卡片背景</span>
              </div>
              <img :src="ruleForm.gameBgp3" alt="" />
            </div>
            <div class="fusion-cad-back prev-upload" v-show="!showCardBack">
              <div
                class="upload-img"
                v-if="ruleForm.gameBgp4"
                @click="toggleShow('gameBgp4')"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>
              <div
                class="switch-card-bg visual-btn"
                @click="showCardBack = !showCardBack"
              >
                <span>查看卡片背景</span>
              </div>
              <img :src="ruleForm.gameBgp4" alt="" />
            </div>
          </div>
          <div class="card-list-wrapper prev-upload">
            <div
              class="visual-btn"
              @click="addCards"
              style="width: 100px; display: block"
              v-if="!ruleForm.cardChipInfoModels.length"
            >
              添加卡片
            </div>
            <div
              class="upload-img"
              @click="addCards"
              style="top: -36px"
              v-if="ruleForm.cardChipInfoModels.length"
            >
              <span class="hmicon icon-hao"></span>
            </div>
            <div
              class="card-list flex"
              :class="{
                'flex-center': ruleForm.cardChipInfoModels.length <= 3
              }"
            >
              <div
                class="card-item prev-upload"
                v-for="(v, i) in ruleForm.cardChipInfoModels"
                :key="i"
              >
                <div
                  class="single-card"
                  :style="{
                    backgroundImage: 'url(' + (v.chipImg || v.cardBg) + ')'
                  }"
                >
                  <div class="upload-img" @click="toggleShow('chipImg', i)">
                    <span class="hmicon icon-shangchuantupian1"></span>
                  </div>
                  <div
                    class="upload-img"
                    style="right: 0; left: unset"
                    @click="deleteCard(i)"
                  >
                    <span class="hmicon hmicon icon-shanchu1 pointer"></span>
                  </div>
                </div>
                <div class="card-name">
                  <input type="text" class="ipt" v-model="v.chipName" />
                </div>
              </div>
            </div>
          </div>
          <div class="phone-btn-wrapper flex flex-around">
            <div
              class="get-card prev-upload"
              :style="{ backgroundImage: 'url(' + ruleForm.gameBgp5 + ')' }"
            >
              <div
                class="upload-img"
                v-if="ruleForm.gameBgp5"
                @click="toggleShow('gameBgp5')"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>
              立即抽卡
            </div>
            <div
              class="do-task prev-upload flex flex-column item-center flex-center"
              :style="{ backgroundImage: 'url(' + ruleForm.gameBgp6 + ')' }"
            >
              <div
                class="upload-img"
                v-if="ruleForm.gameBgp6"
                @click="toggleShow('gameBgp6')"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>
              <div class="title">做任务</div>
              <div class="tips">增加抽卡机会</div>
            </div>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollContainerHeight + 'px' }">
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-width="140px"
          >
            <el-form-item label="活动标题" prop="gameName">
              <el-input size="small" v-model="ruleForm.gameName"></el-input>
            </el-form-item>
            <el-form-item label="活动时间段选择" prop="activityDate">
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                v-model="ruleForm.activityDate"
                :picker-options="pickerOptions"
                type="datetimerange"
                align="right"
                start-placeholder="活动开始时间"
                end-placeholder="活动结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="活动分享文案" prop="gameShareContent">
              <el-input
                :maxlength="30"
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.gameShareContent"
                placeholder="请输入活动分享文案，30字以内"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动规则说明" prop="gameRuleRemark">
              <hm-rich-editor
                v-model="ruleForm.gameRuleRemark"
                :html="ruleForm.gameRuleRemark"
              />
            </el-form-item>
            <el-form-item label="上传背景图" prop="mainImgUrl">
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow('gameBgp')"
                  v-if="!ruleForm.gameBgp"
                >
                  <div class="add-wrapper">
                    <span
                      style="margin: 0"
                      class="hmicon icon-hao pointer"
                    ></span>
                  </div>
                  <span>上传活动背景图</span>
                </div>
                <div v-if="ruleForm.gameBgp" class="priview mr10 flex item-end">
                  <img :src="ruleForm.gameBgp" alt="背景图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow('gameBgp')"
                      >更换</el-button
                    >
                  </div>
                </div>
                <div class="form-tip flex flex-column flex-end">
                  图片尺寸建议750x1334（最多上传一张）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="上传文案图：" prop="gameBgp2">
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow('gameBgp2')"
                  v-if="!ruleForm.gameBgp2"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span class="gray">上传文案图</span>
                </div>

                <div
                  v-if="ruleForm.gameBgp2"
                  class="priview mr10 flex item-end"
                >
                  <img
                    style="width: 200px; height: auto"
                    :src="ruleForm.gameBgp2"
                    alt="文案图："
                  />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow('gameBgp2')"
                      >更换</el-button
                    >
                  </div>
                </div>
                <div class="form-tip flex flex-column flex-end">
                  图片尺寸建议518*98（最多上传一张）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="上传卡片背景图：" prop="gameBgp3">
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow('gameBgp3')"
                  v-if="!ruleForm.gameBgp3"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span class="gray">上传卡片背景图</span>
                </div>

                <div
                  v-if="ruleForm.gameBgp3"
                  class="priview mr10 flex item-end"
                >
                  <img :src="ruleForm.gameBgp3" alt="卡片背景图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow('gameBgp3')"
                      >更换</el-button
                    >
                  </div>
                </div>
                <div class="form-tip flex flex-column flex-end">
                  图片尺寸建议480*644（最多上传一张）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="上传合成卡背景图：" prop="gameBgp4">
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow('gameBgp4')"
                  v-if="!ruleForm.gameBgp4"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span class="gray">上传合成卡背景图</span>
                </div>

                <div
                  v-if="ruleForm.gameBgp4"
                  class="priview mr10 flex item-end"
                >
                  <img :src="ruleForm.gameBgp4" alt="合成卡背景图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow('gameBgp4')"
                      >更换</el-button
                    >
                  </div>
                </div>
                <div class="form-tip flex flex-column flex-end">
                  图片尺寸建议480*644（最多上传一张）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="上传抽奖按钮图：" prop="gameBgp5">
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow('gameBgp5')"
                  v-if="!ruleForm.gameBgp5"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span class="gray">上传抽奖按钮背景图</span>
                </div>
                <div
                  v-if="ruleForm.gameBgp5"
                  class="priview mr10 flex item-end"
                >
                  <img
                    style="width: 200px; height: auto"
                    :src="ruleForm.gameBgp5"
                    alt="抽奖按钮背景图"
                  />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow('gameBgp5')"
                      >更换</el-button
                    >
                  </div>
                </div>
                <div class="form-tip flex flex-column flex-end">
                  图片尺寸建议483*149（最多上传一张）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="上传做任务按钮图：" prop="gameBgp6">
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow('gameBgp6')"
                  v-if="!ruleForm.gameBgp6"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span class="gray">上传做任务按钮图：</span>
                </div>
                <div
                  v-if="ruleForm.gameBgp6"
                  class="priview mr10 flex item-end"
                >
                  <img
                    style="width: 100px; height: auto"
                    :src="ruleForm.gameBgp6"
                    alt="做任务按钮背景图"
                  />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow('gameBgp6')"
                      >更换</el-button
                    >
                  </div>
                </div>
                <div class="form-tip flex flex-column flex-end">
                  图片尺寸建议273*149（最多上传一张）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="获取卡片形式：">
              <el-radio-group v-model="ruleForm.getCardMode" size="small">
                <el-radio label="take">抽卡</el-radio>
                <el-radio label="scan">扫码</el-radio>
              </el-radio-group>
              <div class="form-tip">
                说明:选择抽卡，则显示免费获得抽卡次数的选项，选择扫码，则出现免费获得扫码次数的选项以及公共码
              </div>
            </el-form-item>
            <el-form-item :label="labelText" prop="dailyTakeNum">
              <div>
                <span
                  ><strong>首次</strong> 进入活动可免费{{
                    ruleForm.getCardMode === "take"
                      ? "获得"
                      : "扫公共码获得卡片"
                  }}</span
                >
                <el-input
                  v-model="ruleForm.firstTakeNum"
                  size="small"
                  style="width: 80px"
                  @input="filterInteger('firstTakeNum')"
                ></el-input
                >次
              </div>
              <div>
                <span
                  ><strong>每日</strong> 进入活动可免费{{
                    ruleForm.getCardMode === "take"
                      ? "获得"
                      : "扫公共码获得卡片"
                  }}</span
                ><el-input
                  size="small"
                  style="width: 80px"
                  @input="filterIntegerAndGt0('dailyTakeNum')"
                  v-model="ruleForm.dailyTakeNum"
                ></el-input
                >次
              </div>
            </el-form-item>
            <el-form-item label="单人可合成次数" prop="composeCardNum">
              <el-input
                style="width: 80px"
                size="small"
                clearable
                @input="filterIntegerAndGt0('composeCardNum')"
                class="mr10 ipt"
                v-model.trim="ruleForm.composeCardNum"
              ></el-input>
            </el-form-item>
            <el-form-item label="合成卡片需要数量" prop="completeCardCostNum">
              <el-input
                style="width: 80px"
                size="small"
                clearable
                @change="changeCollectCount"
                @input="filterIntegerAndGt0('completeCardCostNum')"
                class="mr10 ipt"
                v-model.trim="ruleForm.completeCardCostNum"
              ></el-input>
              <div class="form-tip primary">
                说明：修改合成卡片需要数量会清空卡片设置勾选状态
              </div>
            </el-form-item>
            <el-form-item label="卡片设置" prop="cardSetting">
              <el-button @click="addCards" type="text">添加卡片</el-button>
              <div class="table game-select">
                <div class="table-header flex">
                  <div class="flex-1 text-center">序号</div>
                  <div class="flex-1 text-center">卡片名</div>
                  <div class="flex-1 text-center">卡片图</div>
                  <div class="flex-1 text-center">须有此卡才能合成</div>
                  <div
                    class="flex-1 text-center"
                    v-if="ruleForm.getCardMode !== 'take'"
                  >
                    指定码可扫码次数
                  </div>
                  <div class="flex-1 text-center">操作</div>
                </div>
                <div class="table-body">
                  <div
                    class="flex table-row item-center"
                    v-for="(v, i) in ruleForm.cardChipInfoModels"
                    :key="i"
                  >
                    <div class="text-center flex-1">{{ i + 1 }}</div>
                    <div class="flex-1 text-center">
                      <el-input
                        style="width: 120px"
                        v-model.trim="v.chipName"
                        size="small"
                        placeholder="请输入卡片名"
                      ></el-input>
                    </div>
                    <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      <div
                        class="flex goods-upload-btn"
                        @click="toggleShow('chipImg', i)"
                      >
                        <div
                          class="btn flex flex-column flex-center open-file item-center"
                          v-if="!v.chipImg"
                        >
                          <div class="add-prize-img-wrapper">
                            <span class="hmicon icon-hao pointer"></span>
                          </div>
                          <span>添加图片</span>
                        </div>
                        <div v-if="v.chipImg" class="mr10 flex item-end">
                          <img class="logo" :src="v.chipImg" alt="logo" />
                        </div>
                      </div>
                    </div>
                    <div class="flex-1 text-center">
                      <el-checkbox
                        true-label="yes"
                        false-label="no"
                        :disabled="!ruleForm.completeCardCostNum || v.disabled"
                        v-model="v.isNecessary"
                        @change="changeChecked(i)"
                      >
                        {{ v.isNecessary === "yes" ? "是" : "否" }}</el-checkbox
                      >
                    </div>
                    <div
                      class="flex-1 text-center"
                      v-if="ruleForm.getCardMode !== 'take'"
                    >
                      <el-input
                        type="number"
                        maxlength="30"
                        @mousewheel.prevent.native
                        style="width: 140px"
                        v-model.trim="v.scanNum"
                        @input="filterGt0OrFixed('scanNum', i)"
                        size="small"
                        clearable
                        placeholder="请输入扫码次数"
                      ></el-input>
                    </div>
                    <div class="flex-1">
                      <div class="add-wrapper flex flex-center" v-if="i === 0">
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addCards"
                        ></span>
                      </div>
                      <div class="minus-wrapper flex flex-center" v-else>
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteCard(i)"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="活动奖品设置"
              prop="collectCardPrizeRuleModels"
            >
              <div class="table game-select">
                <div class="table-header flex">
                  <div class="flex-1 text-center">奖项</div>
                  <div class="flex-1 text-center">奖品类型</div>
                  <div class="flex-1 text-center">奖品内容</div>
                  <div class="flex-1 text-center">奖品名称</div>
                  <!-- <div class="flex-1 text-center">奖品图片</div> -->
                  <div class="flex-1 text-center">奖品数量</div>
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="数字越小，代表优先级越高，则优先出此奖项。如，一等奖优先级为3，二等奖优先级为2,三等奖优先级为1,则先出三等奖，再出二等奖，最后出一等奖"
                    placement="top"
                  >
                    <div class="flex-1 text-center primary">优先级</div>
                  </el-tooltip> -->
                  <div class="flex-1 text-center">操作</div>
                </div>
                <div class="table-body">
                  <div
                    class="flex table-row item-center"
                    v-for="(item, index) in ruleForm.collectCardPrizeRuleModels"
                    :key="index"
                  >
                    <div class="flex-1 text-center">
                      {{ index + 1 }}
                    </div>
                    <div class="flex-1 text-center">
                      <el-select
                        clearable
                        size="small"
                        @change="clearSendNum"
                        v-model="item.prizeType"
                        placeholder="请选择奖品类型"
                      >
                        <el-option label="优惠劵" value="2"></el-option>
                        <el-option label="实物" value="3"></el-option>
                      </el-select>
                    </div>
                    <div class="flex-1 text-center">
                      <el-select
                        v-if="item.prizeType == '2'"
                        clearable
                        @clear="clearSendNum"
                        size="small"
                        v-model="item.typeValue"
                        @change="changeCoupon"
                        placeholder="请选择优惠券"
                      >
                        <el-option
                          :label="coupon.name"
                          :value="coupon.couponSendId"
                          v-for="(coupon, couponIndex) in couponList"
                          :key="couponIndex"
                        ></el-option>
                      </el-select>
                      <el-input
                        v-if="item.prizeType == '3'"
                        style="width: 140px"
                        v-model.trim="item.typeValue"
                        size="small"
                        clearable
                        placeholder="实物名称"
                      ></el-input>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        style="width: 140px"
                        v-model.trim="item.prizeName"
                        size="small"
                        clearable
                        placeholder="奖品名称"
                      ></el-input>
                    </div>
                    <!-- <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      <div
                        class="flex goods-upload-btn"
                        @click="toggleShow('prizeImg', i)"
                      >
                        <div
                          class="btn flex flex-column flex-center open-file item-center"
                          v-if="!item.prizeImg"
                        >
                          <div class="add-prize-img-wrapper">
                            <span class="hmicon icon-hao pointer"></span>
                          </div>
                          <span>添加图片</span>
                        </div>
                        <div v-if="item.prizeImg" class="mr10 flex item-end">
                          <img class="logo" :src="item.prizeImg" alt="logo" />
                        </div>
                      </div>
                    </div> -->
                    <div class="flex-1 text-center">
                      <el-input
                        type="number"
                        @mousewheel.prevent.native
                        @input="filterGt0OrFixedPrize('prizeNum', index)"
                        style="width: 100px"
                        v-model.trim="item.prizeNum"
                        size="small"
                        placeholder="请输入数量"
                      ></el-input>
                      <div class="limit" v-if="item.sendNum">
                        <span class="primary">
                          数量不得大于{{ item.sendNum }}
                        </span>
                      </div>
                    </div>
                    <!-- <div class="flex-1 text-center">
                      <el-input
                        type="number"
                        @mousewheel.prevent.native
                        style="width: 100px"
                        v-model.trim="item.prizePriority"
                        @input="filterGt0OrFixed('prizePriority', index)"
                        size="small"
                        placeholder="请输入数字"
                      ></el-input>
                    </div> -->
                    <div class="flex-1">
                      <div
                        class="add-wrapper flex flex-center"
                        v-if="index === 0"
                      >
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addPrize(index)"
                        ></span>
                      </div>
                      <div class="minus-wrapper flex flex-center" v-else>
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deletePrize(index)"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="submitForm('ruleForm')"
                >发布</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </el-scrollbar>
      </div>
    </div>
    <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      v-model="showMyUpload"
      v-if="showMyUpload"
      noCircle
      noSquare
      :width="imgWidth"
      :height="imgHeight"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'actCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
import HmRichEditor from "@/components/HmRichEditor";

export default {
  components: {
    myUpload,
    actPreview,
    HmRichEditor
  },
  data() {
    const validGameRuleRemark = (gameRuleRemark, val, callback) => {
      if (!this.ruleForm.gameRuleRemark) {
        return callback(new Error("请输入活动规则说明"));
      }
      callback();
    };
    const validCardSetting = (rule, val, callback) => {
      let flag = true;
      this.ruleForm.cardChipInfoModels.map(v => {
        if (!v.chipName || !v.chipImg) {
          flag = false;
        }
        if (this.ruleForm.getCardMode !== "take" && !v.scanNum) {
          flag = false;
        }
      });
      if (!this.ruleForm.cardChipInfoModels.length) {
        return callback(new Error("请添加卡片"));
      }
      if (flag) {
        callback();
      } else {
        return callback(new Error("请填写所有卡片名并上传卡片图"));
      }
    };

    const validPrizeList = (rule, val, callback) => {
      let flag = true;

      this.ruleForm.collectCardPrizeRuleModels.map(v => {
        if (!v.prizeType || !v.typeValue || !v.prizeName || !v.prizeNum) {
          flag = false;
        }
      });
      if (flag) {
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    };
    return {
      showCardBack: false,
      imgWidth: 0,
      currentCardIndex: 0,
      imgHeight: 0,
      showMyUpload: false,
      vouchersDialogVisible: false,
      selectCouponVisible: false,
      couponList: [],
      ruleForm: {
        gameStartTime: "",
        gameEndTime: "",
        gameBgp:
          "https://imgcdn.hemiao100.com/hemiaoBase/actCenter/1603178865112-f4f5e6e5-51e2-4f1c.png",
        gameBgp2:
          "https://imgcdn.hemiao100.com/hemiaoBase/actCenter/1603178865112-f4f5e6e5-51e2-4f1c1.png",
        gameBgp3:
          "https://imgcdn.hemiao100.com/hemiaoBase/actCenter/group%2010_3.png",
        gameBgp4:
          "https://imgcdn.hemiao100.com/hemiaoBase/actCenter/futionsCard.png",
        gameBgp5:
          "https://imgcdn.hemiao100.com/hemiaoBase/actCenter/psbe6182522dd08f37-cdc7-422a-94a8-3290a63f69a6.png",
        gameBgp6:
          "https://imgcdn.hemiao100.com/hemiaoBase/actCenter/ps35374c1f9a0fa61f-f600-4b84-bd7c-28db7d8da3be.png",
        gameName: "",
        activityDate: [],
        gameId: "",
        type: "",
        gameShareContent: "",
        cardChipInfoModels: [],
        getCardMode: "take",
        firstTakeNum: 0,
        dailyTakeNum: 1,
        gameRuleRemark: "",
        composeCardNum: 1,
        completeCardCostNum: 3,
        collectCardPrizeRuleModels: [
          {
            rankingSeqNum: "",
            prizeType: "2",
            typeValue: "",
            prizeName: "",
            prizeNum: "",
            prizePriority: ""
          }
        ]
      },
      rules: {
        dailyTakeNum: {
          required: true,
          message: "请输入每日免费获得次数",
          trigger: "blur"
        },
        completeCardCostNum: {
          required: true,
          message: "请输入集齐卡片数量",
          trigger: "blur"
        },
        cardSetting: [
          {
            required: true,
            validator: validCardSetting,
            trigger: "blur"
          }
        ],
        composeCardNum: {
          required: true,
          message: "请输入合成次数",
          trigger: "blur"
        },
        collectCardPrizeRuleModels: [
          {
            required: true,
            validator: validPrizeList,
            trigger: "blur"
          }
        ],
        gameName: {
          required: true,
          message: "请输入活动标题",
          trigger: "blur"
        },
        activityDate: {
          required: true,
          message: "请选择活动时间",
          trigger: "blur"
        },
        gameRuleRemark: [
          {
            required: true,
            validator: validGameRuleRemark,
            trigger: "blur"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      }
    };
  },
  computed: {
    labelText() {
      let text = `免费获得${
        this.ruleForm.getCardMode === "take" ? "抽卡" : "扫码"
      }次数：`;
      return text;
    },
    ...mapGetters(["storeStyle"])
  },
  watch: {},
  created() {
    this.gameId = this.$route.query.gameId;
    this.type = this.$route.query.type;
    if (this.gameId) {
      this.queryActDetails();
    }
  },
  mounted() {
    this.$store.dispatch("queryStoreStyle");
    this.queryCoupon();
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcMainEleHeight();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.calcMainEleHeight();
    },
    calcMainEleHeight() {
      setTimeout(() => {
        const headerHeight = this.getBoundingClientRect(".navbar", "y");
        const tagHeight = this.getBoundingClientRect(
          ".tags-view-container",
          "y"
        );
        const stepsHeight = this.getBoundingClientRect(".step-wrapper", "y");
        const footerHeight = this.getBoundingClientRect(".el-footer", "height");
        this.scrollContainerHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          150;
      }, 0);
    },
    getBoundingClientRect(el, type) {
      if (document.querySelector(el)) {
        const result = document.querySelector(el).getBoundingClientRect()[type];
        return result || 0;
      }
      return 0;
    },
    clearSendNum() {
      this.ruleForm.collectCardPrizeRuleModels.forEach(v => {
        v.sendNum = 0;
      });
    },
    changeCoupon(couponSendId) {
      this.ruleForm.collectCardPrizeRuleModels.forEach(v => {
        v.sendNum = this.couponList.find(
          o => o.couponSendId === couponSendId
        ).send_num;
      });
    },
    async queryActDetails() {
      const { result } = await this.$store.dispatch("queryActivitDetail", {
        gameId: this.$route.query.gameId
      });
      if (result) {
        for (let key in result) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = result[key];
          }
        }
        for (let key in result.collectCardModel.collectCardInfoModel) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] =
              result.collectCardModel.collectCardInfoModel[key];
          }
        }
        this.ruleForm.cardChipInfoModels =
          result.collectCardModel.cardChipInfoModels;
        this.ruleForm.collectCardPrizeRuleModels =
          result.collectCardModel.collectCardPrizeRuleModels;
        this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];
      }
    },
    async submitForm(formName) {
      const isValid = await this.$refs[formName].validate();
      if (isValid) {
        let params = {
          gameName: this.ruleForm.gameName,
          gameType: "collect_card",
          gameShareContent: this.ruleForm.gameShareContent,
          gameRuleRemark: this.ruleForm.gameRuleRemark,
          gameBgm: "",
          gameBgp: this.ruleForm.gameBgp,
          gameBgp2: this.ruleForm.gameBgp2,
          gameBgp3: this.ruleForm.gameBgp3,
          gameBgp4: this.ruleForm.gameBgp4,
          gameBgp5: this.ruleForm.gameBgp5,
          gameBgp6: this.ruleForm.gameBgp6,
          gameStartTime:
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "",
          gameEndTime:
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "",
          collectCardModel: {
            collectCardInfoModel: {
              getCardMode: this.ruleForm.getCardMode,
              firstTakeNum: this.ruleForm.firstTakeNum,
              dailyTakeNum: this.ruleForm.dailyTakeNum,
              composeCardNum: this.ruleForm.composeCardNum,
              completeCardCostNum: this.ruleForm.completeCardCostNum
            },
            cardChipInfoModels: this.ruleForm.cardChipInfoModels,
            collectCardPrizeRuleModels: this.ruleForm.collectCardPrizeRuleModels
          }
        };
        await this.$store.dispatch("saveCollectGame", params);
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.$router.back(-1);
      }
    },
    setLink() {},
    async queryCoupon() {
      const { result } = await this.$store.dispatch("findCouponSendByEvent");
      if (result) {
        this.couponList = result;
      }
    },
    filterGt0OrFixed(prop, i) {
      this.ruleForm.cardChipInfoModels[i][
        prop
      ] = this.ruleForm.cardChipInfoModels[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.cardChipInfoModels[i][
        prop
      ] = this.ruleForm.cardChipInfoModels[i][prop]
        .replace(".", "")
        .replace("-", "");
      this.ruleForm.cardChipInfoModels[i][
        prop
      ] = this.ruleForm.cardChipInfoModels[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixedPrize(prop, i) {
      this.ruleForm.collectCardPrizeRuleModels[i][
        prop
      ] = this.ruleForm.collectCardPrizeRuleModels[i][prop].replace(
        /^(0+)/,
        ""
      ); //过滤0开头
      this.ruleForm.collectCardPrizeRuleModels[i][
        prop
      ] = this.ruleForm.collectCardPrizeRuleModels[i][prop]
        .replace(".", "")
        .replace("-", "");
      this.ruleForm.collectCardPrizeRuleModels[i][
        prop
      ] = this.ruleForm.collectCardPrizeRuleModels[i][prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    },
    changeChecked() {
      const checkdCount = this.ruleForm.cardChipInfoModels.filter(
        v => v.isNecessary
      ).length;
      this.ruleForm.cardChipInfoModels.forEach(v => {
        if (checkdCount >= this.ruleForm.completeCardCostNum) {
          if (v.isNecessary === "no") {
            v.disabled = true;
          }
        } else {
          v.disabled = false;
        }
      });
    },
    changeCollectCount() {
      this.ruleForm.cardChipInfoModels.forEach(v => {
        v.isNecessary = "no";
        v.disabled = false;
      });
    },
    addCards() {
      this.ruleForm.cardChipInfoModels.push({
        cardBg: this.ruleForm.gameBgp3,
        chipImg: ""
      });
      this.changeChecked();
    },
    deleteCard(i) {
      this.ruleForm.cardChipInfoModels.splice(i, 1);
      this.changeChecked();
    },
    addPrize() {
      this.ruleForm.collectCardPrizeRuleModels.push({
        rankingSeqNum: "",
        prizeType: "2",
        typeValue: "",
        prizeName: "",
        prizeNum: "",
        prizePriority: ""
      });
    },
    deletePrize(i) {
      this.ruleForm.collectCardPrizeRuleModels.splice(i, 1);
    },
    removeCards() {},
    toggleShow(type, i) {
      this.uploadType = type;
      this.currentCardIndex = i;
      switch (this.uploadType) {
        case "gameBgp":
          this.imgWidth = 750;
          this.imgHeight = 1334;
          break;
        case "gameBgp2":
          this.imgWidth = 518;
          this.imgHeight = 98;
          break;
        case "gameBgp3":
        case "gameBgp4":
        case "chipImg":
          this.imgWidth = 480;
          this.imgHeight = 644;
          break;
        case "gameBgp5":
          this.imgWidth = 483;
          this.imgHeight = 149;
          break;
        case "gameBgp6":
          this.imgWidth = 273;
          this.imgHeight = 149;
          break;
        default:
          this.imgWidth = 750;
          this.imgHeight = 1334;
          break;
      }
      this.showMyUpload = true;
    },
    cropUploadSuccess(jsonData) {
      if (this.uploadType !== "chipImg") {
        this.ruleForm[this.uploadType] = jsonData.result;
      } else {
        this.ruleForm.cardChipInfoModels[this.currentCardIndex][
          this.uploadType
        ] = jsonData.result;
      }
    },

    filterInteger(prop) {
      if (this.ruleForm[prop]) {
        this.ruleForm[prop] = +this.ruleForm[prop].replace(/[^0-9]/g, "");
      }
    },
    filterIntegerAndGt0(prop) {
      if (this.ruleForm[prop]) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    }
  }
};
</script>
<style lang="scss">
.game-select {
  .el-select {
    width: 140px !important;
    .el-input {
      width: 140px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.fixed-but {
  position: fixed;
  top: 150px;
  right: 20px;
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .upload-upload-btn {
    .tips {
      color: #999;
      font-size: 12px;
      line-height: 20px;
    }

    .btn {
      border: 1px solid #ddd;
      text-align: center;
      padding: 10px;
      margin-right: 10px;
      width: 130px;
      height: 130px;
      cursor: pointer;
      .add-wrapper {
        width: 30px;
        height: 30px;
        line-height: 30px;
        background: #e50065;
        color: #fff;
        text-align: center;
        border-radius: 50%;
        margin: 0 auto;
        span {
          font-size: 12px;
        }
        cursor: pointer;
        .hmicon {
          font-size: 14px;
        }
      }
    }
  }
  .priview {
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    img {
      height: 200px;
    }
    .opreat-wrapper {
      transition: opacity 0.2s linear;
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 6px;
    }

    &:hover {
      .opreat-wrapper {
        opacity: 1;
      }
    }
  }
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .slot {
    position: relative;
    background-size: 100% 100%;
    height: 100%;
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .title-img {
      position: absolute;
      left: 50%;
      top: 57px;
      transform: translateX(-50%);
      img {
        width: 259px;
      }
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    .card-back {
      position: absolute;
      left: 50%;
      top: 128px;
      transform: translateX(-50%);
      &:hover {
        .switch-card-bg {
          display: block;
        }
      }
      .normarl-card-back,
      .fusion-cad-back {
        img {
          width: 240px;
        }
      }
      .switch-card-bg {
        position: absolute;
        left: 36px;
        top: 0;
      }
    }
    .card-list-wrapper {
      position: absolute;
      top: 468px;
      left: 15px;
      right: 15px;
      .card-list {
        overflow-x: auto;
        .card-item {
          flex-shrink: 0;
          margin-right: 15px;
        }
        .single-card {
          width: 72px;
          height: 96px;
          background-size: 100% 100%;
        }
        .card-name {
          height: 18px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          .ipt {
            background: transparent;
            color: #fff;
            text-align: center;
            font-size: 12px;
            border: none;
            outline: none;
            width: 72px;
          }
        }
      }
    }
    .phone-btn-wrapper {
      position: absolute;
      top: 600px;
      left: 0;
      right: 0;
      .get-card,
      .do-task {
        border: none;
      }
      .get-card {
        width: 210px;
        height: 43px;
        line-height: 43px;
        background-size: 100% 100%;
        font-size: 18px;
        font-weight: bold;
        color: #f82c2c;
        text-align: center;
      }
      .do-task {
        width: 105px;
        height: 43px;
        background-size: 100% 100%;
        text-align: center;
        .title {
          font-size: 16px;
          color: #fff;
        }
        .tips {
          font-size: 12px;
          color: #ffc66e;
        }
      }
    }
  }
}

.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
  .qrcode {
    width: 134px;
  }
  .goods-upload-btn {
    .tips {
      color: #999;
      font-size: 12px;
      line-height: 20px;
    }

    .logo {
      width: 100px;
    }

    .btn {
      border: 1px solid #ddd;
      text-align: center;
      padding: 10px;
      width: 80px;
      height: 80px;
      cursor: pointer;
      .add-wrapper {
        width: 30px;
        height: 30px;
        line-height: 30px;
        background: #e50065;
        color: #fff;
        text-align: center;
        border-radius: 50%;
        margin: 0 auto;
        span {
          font-size: 12px;
        }
        cursor: pointer;
        .hmicon {
          font-size: 14px;
          margin-right: 0 !important;
        }
      }
    }
  }
  .add-prize-img-wrapper {
    width: 20px;
    height: 20px;
    line-height: 20px;
    background: #e50065;
    color: #fff;
    text-align: center;
    border-radius: 50%;
    user-select: none;
    .hmicon {
      font-size: 14px;
      margin-right: 0;
    }
  }
}

.limit {
  font-size: 12px;
  line-height: 12px;
}
</style>
